import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import { configuration } from "../../helper/appconfig";
import toastAlert from "../../helper/ToastAlert/ToastAlert";
import { IconButton } from "@mui/material";
import { Link } from "react-router-dom";
import { handleAuthTokenError } from "../../redux/actions/authActions";
import VisibilityIcon from '@mui/icons-material/Visibility';
import GradingOutlinedIcon from '@mui/icons-material/GradingOutlined';
import StyledTable from '../../components/StyledTable';

const GroupTableValue = () => [
    {
        name: "Index",
        options: {
            filter: false,
            sort: false,
            customBodyRender: (value) => {
                if (value) {
                    return (
                        <div className="table_data table_data_index">
                            <p>{value}</p>
                        </div>
                    );
                }
            },
        },
    },
    {
        name: "Provision Id",
        options: {
            filter: true,
            customBodyRender: (value) => {
                if (value) {
                    return (
                        <div className="table_data">
                            <p style={{ fontFamily: "'Courier New', monospace", fontSize: '12px' }}>{value}</p>
                        </div>
                    );
                }
            },
        },
    },
    {
        name: "Obtained Marks",
        options: {
            filter: true,
            customBodyRender: (value) => {
                return (
                    <div className="table_data">
                        <p style={{ fontWeight: 600 }}>{value}</p>
                    </div>
                );
            },
        },
    },
    {
        name: "Updated At",
        options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => {
                let formatted = value;
                if (value) {
                    let dateObj = null;
                    if (!isNaN(value) && String(Number(value)).length >= 10) {
                        dateObj = new Date(Number(value) * 1000);
                    } else if (!isNaN(Date.parse(value))) {
                        dateObj = new Date(value);
                    }
                    if (dateObj && !isNaN(dateObj.getTime())) {
                        const mm = String(dateObj.getMonth() + 1).padStart(2, '0');
                        const dd = String(dateObj.getDate()).padStart(2, '0');
                        const yyyy = dateObj.getFullYear();
                        formatted = `${mm}/${dd}/${yyyy}`;
                    }
                }
                return (
                    <div className="table_data">
                        <p style={{ color: '#666', fontSize: '12px' }}>{formatted}</p>
                    </div>
                );
            },
        },
    },
    {
        name: "Action",
        options: {
            filter: false,
            sort: false,
            customBodyRender: (value) => {
                return (
                    <Link
                        to={{
                            pathname: `/viewGradingHistory/${value}`,
                            state: { provision_id: value },
                        }}
                    >
                        <IconButton title="View" size="small" style={{ color: '#6AB43E' }}>
                            <VisibilityIcon fontSize="small" />
                        </IconButton>
                    </Link>
                );
            },
        },
    },
];

class GradingHistory extends Component {
    constructor() {
        super();
        this.state = {
            gradingHistoryArr: [],
            loading: false,
            selectedId: null,
            userData: [],
        };
    }

    componentDidMount() {
        this.getGradeHistory();
    }

    itemArray = () => {
        return [
            {
                name: "Grading History",
                active: false,
                link: "",
            },
            {
                name: "History",
                active: true,
                link: "",
            },
        ];
    };

    renderGradeHistoryData = () => {
        const { gradingHistoryArr } = this.state;

        if (!gradingHistoryArr?.length) return [];

        const excludedKeys = ['provisionid', 'userid', 'tenantid'];
        let resultData = [];

        gradingHistoryArr.forEach((group, idx) => {
            const normalizedGroup = Object.fromEntries(
                Object.entries(group).map(([key, value]) => [key.toLowerCase(), value])
            );

            const groupKeys = Object.keys(normalizedGroup).filter(
                (key) => !excludedKeys.includes(key)
            );

            let totalMaximumMarks = 0;
            let totalObtainedMarks = 0;

            groupKeys.forEach((serverName) => {
                const serverData = normalizedGroup[serverName];
                if (serverData) {
                    Object.values(serverData).forEach((data) => {
                        totalMaximumMarks += parseInt(data.maximum_marks || 0, 10);
                        totalObtainedMarks += parseInt(data.obtained_maximum_marks || 0, 10);
                    });
                }
            });

            const provisionId = normalizedGroup.provisionid || "N/A";
            const updatedAt = group?.updatedAt || group?.timestamp || "-";

            resultData.push([
                idx + 1,
                group?.provisionId,
                `${totalObtainedMarks && totalMaximumMarks ? (totalObtainedMarks + '/' + totalMaximumMarks) : '0/0'}`,
                updatedAt,
                provisionId,
            ]);
        });

        return resultData;
    };

    getGradeHistory = () => {
        this.setState({ loading: true });
        const url = configuration.gradeResults;
        const tokenType = this.props?.authData?.tokenType;
        const idToken = this.props?.authData?.idToken;
        const headers = {
            Authorization: `${tokenType} ${idToken}`,
        };

        axios
            .get(url, { headers })
            .then((response) => {
                this.setState({
                    gradingHistoryArr: response?.data?.grades,
                    loading: false,
                });
            })
            .catch((error) => {
                let errorMessage = error?.response?.data?.message;
                if (errorMessage === "Unauthorized") {
                    this?.props?.handleAuthTokenError(this.props);
                }
                this.setState({ loading: false });
                if (!error.response) {
                    toastAlert("Please check your internet connection.", "error");
                } else {
                    toastAlert(
                        errorMessage || "Something went wrong. Please try again later.",
                        "error"
                    );
                }
            });
    };

    render() {
        const { loading, gradingHistoryArr } = this?.state;

        return (
            <div>
                <Breadcrumb items={this?.itemArray()} />
                <StyledTable
                    title="Grading History"
                    icon={<GradingOutlinedIcon />}
                    subtitle={gradingHistoryArr?.length ? `${gradingHistoryArr.length} graded submissions` : undefined}
                    loading={loading}
                    data={this.renderGradeHistoryData()}
                    columns={GroupTableValue()}
                    emptyMessage="No grading history found"
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    authData: state.authReducer,
});

export default connect(mapStateToProps, { handleAuthTokenError })(GradingHistory);
